import angular from 'angular';
import controller from './password.controller';
import template from './password.html';
import './password.scss';
import PasswordComponent from './password.component';

const passwordConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('password', {
		title:      'Password',
		template,
		children:   false,
		selectable: true,
		settings:   new PasswordComponent(),
		icon: 'fa fa-asterisk',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/password/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/textfield/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller,
	});
};

export default angular.module('app').config(passwordConfig);
